<template>
    <div class="report-container" ref="container">
        <report-view ref="reportView"></report-view>
        <div class="resizer" @mousedown="resizeMouseDown" @mousemove="resizeMouseMove" @mouseup="resizeMouseUp"></div>
        <div class="resize-surface" ref="resizeSurface" @mousemove="surfaceMouseMove" @mouseup="surfaceMouseUp"></div>
    </div>    
</template>

<script>

import $ from '@/lib/JQuery.js'
import logger from '@/lib/logger.js'
import { SampleReportData } from '@/lib/SampleData.js'
import { ServiceController } from '@/lib/ServiceController.js'
import events from '@/lib/events.js'
import config from '@/lib/config.js'
import ReportView from '@/components/ReportView.vue'

export default {
    name: 'ReportContainer',
    components: {  
        ReportView
    },
    data() {
        return {
            isResizing: false
        }
    },
    methods: {
        openReport() {
            logger.log('ReportContainer::openReport()')
            
            $(this.$refs.container).fadeIn()
            this.$refs.reportView.clearReport()
            this.$refs.reportView.$on('close', () => { $(this.$refs.container).fadeOut() })
            
            if (config.useSampleChartData) {
                setTimeout(() => { 
                this.$refs.reportView.updateReport(SampleReportData) 
                }, 500)
            }
            else {
                ServiceController.defaultReportData(
                    (data) => {
                        logger.log('Updating reportView and switching currentView to report', data)        
                        this.$refs.reportView.updateReport(data)
                    }, 
                    (error) => {
                        events.$emit(events.EVT_ERROR, 'Error getting report data from the server: ' + error)
                    })
            }
        },
        resizeMouseDown(event) {
            logger.log('resizeMouseDown', event)                
            this.isResizing = true      
            $(this.$refs.resizeSurface).fadeIn()
        },
        resizeMouseMove(event) {
            logger.log('resizeMouseMove', event)
        },
        resizeMouseUp(event) {
            logger.log('resizeMouseUp', event)        
            this.endResize()
        },
        surfaceMouseMove(event) {
            logger.log('surfaceMouseMove', event)

            if (!this.isResizing)
                return

            let surfaceWidth = this.$refs.resizeSurface.offsetWidth
            let newWidth = Math.min(surfaceWidth, Math.max(300, surfaceWidth - event.clientX))
            this.$refs.container.style.width = newWidth + 'px'
        },
        surfaceMouseUp(event) {
            logger.log('surfaceMouseUp', event)
            this.endResize()
        },
        endResize() {
            this.isResizing = false
            $(this.$refs.resizeSurface).fadeOut()
        }
    }
}
</script>

<style>
.report-container {
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;  
  background-color: white;
  border: 1px solid black;
  z-index: 1101;
  display: none;
}

.report-container .resizer {
  position: absolute;
  left: -5px;
  top: 50%;
  width: 10px;
  height: 40px;
  margin-top: -20px;
  background-color: #333355;
  border-radius: 4px;
  cursor: ew-resize;
  z-index: 1102;
  -webkit-user-select: none; 
  -moz-user-select: none; 
  -ms-user-select: none; 
  user-select: none;   
}

.resize-surface {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.3);
  z-index: 1102;
  display: none;
}

@media screen and (min-width: 601px) {
  .report-container {
    width: 600px;
    max-width: 100%;
  }  
}

@media screen and (max-width: 600px) {
  .report-container{
    width: initial !important;
    left: 0;    
  }

  .report-container .resizer {
    display: none;
  }
}
</style>